import _isFinite from 'lodash/isFinite';

/**
 * Parses a number input and returns true if the input is a valid finite formatted string.
 * @param {string} value
 * @returns boolean
 */
export const isValidNumber = (value) => _isFinite(parseFloat(value));
